// util.js — малки помощни функции.

function str(v, max = 2000) {
  if (v === undefined || v === null) return '';
  return String(v).slice(0, max).trim();
}

function num(v, def = 0) {
  // Празно/липсващо дава ПОДРАЗБИРАЩАТА СЕ стойност (преглед 17.09.2026):
  // Number('') е 0 и минаваше през isFinite — „по подразбиране 1" за
  // количество никога не работеше, изчистено поле правеше реда с 0 стойност.
  if (v === undefined || v === null || v === '') return def;
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
}

function bool(v) {
  return v === true || v === 1 || v === '1' || v === 'true';
}

function isEmail(v) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || ''));
}

// IBAN на ЕДНО място (15.09.2026, изравнено при прегледа на 17.09):
// каноновият вид (главни букви, без интервали) е свойство на ПОЛЕТО, не на
// адреса, който пише — иначе клиентският PATCH и админският PUT оставят
// две различни истини в същата колона. Проверява се само НЕПРАЗЕН низ:
// заварени стойности, които не са IBAN, не бива да чупят стар запис.
function cleanIban(v) {
  return str(v, 50).toUpperCase().replace(/\s+/g, '');
}
// Истинската проверка — дължина и контролно число (services/iban.js).
function isIban(v) {
  return require('./services/iban').isValid(v);
}

// Номер на запис — ЕДНО преобразуване за цялата система.
//
// Защо съществува: базата намираше записа с Number(id), а пазачът по фирма
// разпознаваше номера с израз само за цифри. Number() приема много повече от
// цифри — „5.0", „+5", „5e0", „0x5", „ 5" — и всяко от тях стигаше до запис 5,
// без пазачът да го е видял. Затова тук номерът е ЕДИН вид: цели положителни
// цифри и нищо друго. Ползват го и db-json.js, и db-sqlite.js, и companyGuard,
// значи двете страни няма как да се разминат отново.
// Връща число или null, когато стойността не е номер на запис.
function normalizeId(v) {
  if (typeof v === 'number') {
    return Number.isSafeInteger(v) && v > 0 ? v : null;
  }
  if (typeof v !== 'string') return null;
  if (!/^[0-9]+$/.test(v)) return null;
  const n = Number(v);
  return Number.isSafeInteger(n) && n > 0 ? n : null;
}

// „Днес" по софийско време (преглед 17.09.2026): контейнерът върви в UTC и
// new Date().toISOString() между полунощ и 2–3 ч. българско връщаше
// ВЧЕРАШНАТА дата — изтекла застраховка минаваше за „изтичаща днес", а
// панелът „разходи за месеца" показваше август под заглавие септември.
// 'sv-SE' форматът е точно ГГГГ-ММ-ДД.
function todaySofia() {
  return new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Sofia' });
}

// Връща грешка като JSON и спира.
function fail(res, code, msg) {
  return res.status(code).json({ error: msg });
}

// Content-Disposition с име, което може да носи кирилица (преглед 17.09.2026):
// HTTP заглавките приемат само Latin-1 — кирилска представка на номер
// (напр. „ПФ-000001") караше res.setHeader да хвърли ERR_INVALID_CHAR и
// ВСЕКИ такъв PDF връщаше „Грешка при генериране". ASCII резерва за стари
// клиенти + filename* (RFC 5987) за истинското име.
function contentDisposition(type, filename) {
  const name = String(filename || 'file');
  const ascii = name.replace(/[^\x20-\x7E]/g, '_').replace(/["\\]/g, '_');
  return type + '; filename="' + ascii + '"; filename*=UTF-8\'\'' + encodeURIComponent(name);
}

module.exports = { str, num, bool, isEmail, cleanIban, isIban, normalizeId, fail, contentDisposition, todaySofia };
